import * as React from "react";
import PropTypes from "prop-types";
import Backbone from "backbone";
import Button from "nx-components/Button";
import ButtonGroup from "nx-components/ButtonGroup";
import {
  IconChevronDown,
  IconCircle,
  IconChevronUp,
} from "nx-components/Icons";
import CommonControlWrapper from "nexia_mobile/components/Controls/wrappers/CommonControlWrapper";

const WindowShadeOpenCloseStop = ({
  model,
  isDetailed,
  showSpinner,
  hideSpinner,
}) => {
  let styles = {
    wrapper: {
      fontSize: "0.8em",
      width: "100%",
    },
    button: {
      lineHeight: 0, // ignore icon height
    },
  };

  return (
    <CommonControlWrapper isDetailed={isDetailed}>
      <div style={styles.wrapper}>
        <ButtonGroup>
          <Button
            style={styles.button}
            onTap={() => {
              showSpinner(`Closing '${model.get("name")}'`);
              model.close().then(hideSpinner, hideSpinner);
            }}
          >
            <IconChevronDown />
          </Button>
          <Button
            style={styles.button}
            onTap={() => {
              showSpinner(`Stopping '${model.get("name")}'`);
              model.stop().then(hideSpinner, hideSpinner);
            }}
          >
            <IconCircle />
          </Button>
          <Button
            style={styles.button}
            onTap={() => {
              showSpinner(`Opening '${model.get("name")}'`);
              model.open().then(hideSpinner, hideSpinner);
            }}
          >
            <IconChevronUp />
          </Button>
        </ButtonGroup>
      </div>
    </CommonControlWrapper>
  );
};
WindowShadeOpenCloseStop.propTypes = {
  model: PropTypes.instanceOf(Backbone.Model).isRequired,
  isDetailed: PropTypes.bool.isRequired,
  showSpinner: PropTypes.func.isRequired, // (?string) => void
  hideSpinner: PropTypes.func.isRequired, // () => void
};

export default WindowShadeOpenCloseStop;



// WEBPACK FOOTER //
// ./src/components/Controls/WindowShadeOpenCloseStop.jsx